import React, { Fragment } from 'react';

import materiales from './materiales.jpg';
import materialesMobile from './materiales-mobile.jpg';

import './styles.css';

export const MaterialsDiv = () => (
   <Fragment>
      <img src={materiales} alt="A lo Venezolano" className="materiales only-desktop"/>
      <img src={materialesMobile} alt="A lo Venezolano" className="materiales only-mobile"/>
   </Fragment>
);